import apiClient from './apiClient';

const getAppConfig = () => apiClient.get('/app_config');

export default getAppConfig;
